
// import { useState, useEffect, useContext } from "react";
// import MainLayouts from "../../../Layout/MainLayouts";
// import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
// import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
// import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
// import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";
// import { ReactComponent as CardList } from "bootstrap-icons/icons/card-list.svg";
// import { ReactComponent as CardHeading } from "bootstrap-icons/icons/card-heading.svg";
// import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
// import Spinner from "../../spinner/Spinner";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import ApiServices from "../../../api/ApiServices";
// import { toast } from "react-toastify";
// import DataTable from "react-data-table-component";
// import Swal from "sweetalert2";
// import CustomStyles from "../../../components/utils/CustomStyles";
// import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
// import { handleError } from "../../../components/utils/AuthenticationCheck";
// import AxiosApiCall from "../../../api/AxiosApiCall";
// import { AuthContext } from "../../../AuthProvider/AuthProvider";
// import formatDate from "../../../components/utils/DateFormatter";


// const BranchProductList = () => {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [current_page, setCurrentPage] = useState(1);
//   const [per_page, setPerPage] = useState(20);
//   const [total, setTotal] = useState(0);
//   const [filterText, setFilterText] = useState("");
//   const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
//   const [confirmationLoading, setConfirmationLoading] = useState(false);
//   const { permissions } = useContext(AuthContext);
//   // console.log("this is all the perm", permissions);

//   const navigate = useNavigate();

//   //axios api encryption call
//   const axios = AxiosApiCall();

//   const fetchAllproductList = async () => {
//     setLoading(true);
//     try {
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) {
//         throw new Error("No access token found.");
//       }

//       const payload = {
//         per_page,
//         page: current_page,
//       };

//       const response = await axios.post(
//         ApiServices.getAllBranchProduct,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           withCredentials: true,
//         }
//       );

//       // The response structure is different than what you're expecting
//       const resData = response.data?.data || {};
//       const status = response.data?.status;
//       const message = response.data?.message;

//       // console.log("API Response:", {
//       //   status: status,
//       //   message: message,
//       //   data: resData
//       // });

//       if (status === "200" || status === 200) {
//         // The actual products array is in resData.data
//         const productsData = Array.isArray(resData.data) ? resData.data : [];
//         setProducts(productsData);

//         // Pagination data comes from resData
//         setTotal(resData.total || productsData.length);
//         setCurrentPage(resData.current_page || 1);
//         setPerPage(resData.per_page || 20);

//         toast.success(message, { toastId: "branch-product-fetch-success" });
//       } else {
//         handleError({ response: { status, data: { message } } }, navigate);
//       }
//     } catch (error) {
//       console.error("Fetch error:", error);
//       handleError(error, navigate);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAllproductList();
//   }, [current_page, per_page]);


//   // Handle Delete Confirmation
//   const handleDeleteConfirmation = (Id) => {
//     setConfirmationLoading(true);
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       setConfirmationLoading(false);
//       if (result.isConfirmed) {
//         handleDeleteProduct(Id);
//       }
//     });
//   };

//   // Handle Product Deletion
//   const handleDeleteProduct = async (Id) => {
//     const formData = {
//       id: Id,
//     };
//     try {
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) {
//         throw new Error("No access token found.");
//       }
//       const response = await axios.delete(ApiServices.deleteBranchProduct, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         data: formData,
//         withCredentials: true,
//       });

//       const updatedProduct = products.filter(
//         (product) => product.id !== Id
//       );
//       setProducts(updatedProduct);

//       const { status, message } = response.data;
//       if (status === 200) {
//         toast.success(message);
//       } else {
//         handleError({ response: { status, data: { message } } }, navigate);
//       }
//     } catch (error) {
//       handleError(error, navigate);
//     } finally {
//       setLoading(false);
//     }
//   };


//   const handleFilter = (e) => {
//     setFilterText(e.target.value);
//     setResetPaginationToggle(!resetPaginationToggle);
//   };

//   // Define Expandable Component for Actions
//   const ExpandableComponent = ({ data }) => (
//     <div className="flex justify-start p-4 relative">
//       {permissions.some(permission => permission.name === 'admin.view') && (
//         <div className="mx-2 my-2 group relative">
//           <Link
//             to="/operations/branch/products/details"
//             state={{ data }}
//           >
//             <Eye className="w-5 h-5 text-darkGreen3 " />
//           </Link>
//           <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block  text-darkGreen3 text-xs px-2 py-1 rounded">
//             Details
//           </div>
//         </div>
//       )}
//       {permissions.some(permission => permission.name === 'admin.edit') && (
//         <div className="mx-2 my-2 group relative">
//           <Link
//             to="/operations/branch/products/edit"
//             state={{ data }}
//           >
//             <PencilSquare className="w-5 h-5 text-dash4 " />
//           </Link>
//           <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash4 text-xs px-2 py-1 rounded">
//             Edit
//           </div>
//         </div>
//       )}

//       {permissions.some(permission => permission.name === 'admin.create') && (
//         <div className="mx-2 my-2 group relative">
//           <button
//             onClick={() => handleDeleteConfirmation(data.id)}
//             disabled={confirmationLoading}
//           >
//             <Trash className="w-5 h-5 text-dash3 " />
//           </button>
//           <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash3 text-xs px-2 py-1 rounded">
//             Delete
//           </div>
//         </div>
//       )}


//     </div>
//   );


//   const columns = [
//     {
//       name: "Product Name",
//       selector: (row) => (row.product_units_name ? row.product_units_name.replace(/_/g, ' ').toUpperCase() : ""),
//       sortable: true,
//       width: "200px",
//     },
//     {
//       name: "Product Code",
//       selector: (row) => (row.product_code ? row.product_code.toUpperCase() : ""),
//       sortable: true,
//       width: "180px",
//     },
//     {
//       name: "Unit",
//       selector: (row) => (row.unit ? row.unit.toUpperCase() : ""),
//       sortable: true,
//       width: "100px",
//     },
//     {
//       name: "Price",
//       selector: (row) => (row.base_price ? CurrencyFormatter(row.base_price) : ""),
//       sortable: true,
//       width: "150px",
//     },

//     // {
//     //   name: "Category",
//     //   sortable: true,
//     //   width: "200px",
//     //   cell: (row) => (
//     //     <div>
//     //       <span className="block font-bold">
//     //         {row.product_categories_name
//     //           ? row.product_categories_name.replace(/_/g, ' ').toUpperCase()
//     //           : "NOT AVAILABLE"}
//     //       </span>
//     //       {/* <span className="px-3 py-0.5 rounded-md bg-orange1 text-lGrey2 text-xs">
//     //         {row.sub_category_name
//     //           ? row.sub_category_name.toLowerCase()
//     //           : "NOT AVAILABLE"}
//     //       </span> */}
//     //     </div>
//     //   ),
//     // },
//     {
//       name: "Status",
//       sortable: true,
//       cell: (row) => (
//         <span className={row.is_enabled ? "text-dash" : "text-dash3"}>
//           {row.is_enabled ? "ACTIVE" : "INACTIVE"}
//         </span>
//       ),
//       width: "100px",
//     },
//     {
//       name: "Date Created",
//       selector: (row) => row.created_at ? formatDate(row.created_at) : "NOT AVAILABLE",
//       sortable: true,
//       width: "200px",
//     },

//   ];



//   const filteredItems = products.filter(item => {
//     if (!item) return false;
//     const searchStr = filterText.toLowerCase();
//     return (
//       String(item.product_units_name || '').toLowerCase().includes(searchStr) ||
//       String(item.product_code || '').toLowerCase().includes(searchStr) ||
//       String(item.unit || '').toLowerCase().includes(searchStr) ||
//       String(item.base_price || '').includes(searchStr) ||
//       String(item.product_categories_name || '').toLowerCase().includes(searchStr)
//     );
//   });


//   const data = filteredItems.map((products) => ({
//     product_units_name: products.product_units_name || "NOT AVAILABLE",
//     product_code: products.product_code,
//     unit: products.unit || "NOT AVAILABLE",
//     base_price: products.description,
//     status: products.status,
//     product_categories_name: products.product_categories_name,
//     created_at: products.created_at,
//     product_code: products.product_code,
//     is_active: products.is_active
//   }));

//   const sortedData = [...data].sort((a, b) => {
//     const dateA = new Date(a.created_at);
//     const dateB = new Date(b.created_at);
//     return dateB - dateA;
//   });

//   return (
//     <div>
//       <MainLayouts>
//         <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
//           <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
//             <nav className="bg-gray-200 py-0 px-4 rounded-lg">
//               <ol className="list-none p-0 inline-flex mb-2">
//                 <li className="flex items-center">
//                   <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                     Operations
//                   </p>
//                   <ChevronRightIcon />
//                 </li>
//                 <li className="flex items-center">
//                   <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                     Branch
//                   </p>
//                   <ChevronRightIcon />
//                 </li>
//                 <li className="flex items-center">
//                   <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                     Stock
//                   </p>
//                   <ChevronRightIcon />
//                 </li>
//                 <li className="flex items-center">
//                   <p className="text-orange1">List</p>
//                 </li>
//               </ol>
//             </nav>
//           </section>
//           <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
//             <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
//               <input
//                 type="search"
//                 className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
//                 placeholder="Search"
//                 value={filterText}
//                 onChange={handleFilter}
//               />
//             </div>
//             {permissions.some(permission => permission.name === 'admin.view') && (
//               <Link
//                 to="/operations/branch/products/create"
//                 className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
//               >
//                 <span className="flex justify-center sm:justify-start mx-2">
//                   <PlusSquareFill className="mr-2" />
//                   Create Branch Stock
//                 </span>
//               </Link>
//             )}
//           </div>
//           {loading ? (
//             <Spinner />
//           ) : (


//             <DataTable
//               columns={columns}
//               data={sortedData}
//               pagination
//               paginationServer
//               paginationTotalRows={total}
//               paginationDefaultPage={current_page}
//               paginationPerPage={per_page}
//               onChangePage={setCurrentPage}
//               onChangeRowsPerPage={(perPage) => {
//                 setPerPage(perPage);
//                 setCurrentPage(current_page);
//               }}
//               highlightOnHover
//               striped
//               customStyles={CustomStyles}
//               noDataComponent={
//                 <div className="p-4 text-center text-gray-500">
//                   {products.length === 0 ? "No products available" : "No matching products found"}
//                 </div>
//               }
//               expandableRows
//               expandableRowsComponent={ExpandableComponent}
//               progressPending={loading}
//               progressComponent={<Spinner />}
//               persistTableHead
//             />

//           )}
//         </div>
//       </MainLayouts >
//     </div >
//   );
// };

// export default BranchProductList;


import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";
import { ReactComponent as CardList } from "bootstrap-icons/icons/card-list.svg";
import { ReactComponent as CardHeading } from "bootstrap-icons/icons/card-heading.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import { ReactComponent as ShieldFillPlus } from "bootstrap-icons/icons/shield-fill-plus.svg";
import { ReactComponent as ArrowLeftSquareFill } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import Spinner from "../../spinner/Spinner";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../../components/utils/CustomStyles";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../../api/AxiosApiCall";
import { AuthContext } from "../../../AuthProvider/AuthProvider";
import formatDate from "../../../components/utils/DateFormatter";


const BranchProductList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [current_page, setCurrentPage] = useState(1);
  const [per_page, setPerPage] = useState(20);
  const [total, setTotal] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [branchId, setBranchId] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const { permissions } = useContext(AuthContext);

  const navigate = useNavigate();
  const location = useLocation();
  const { data, branch_id } = location.state || {};



  useEffect(() => {
    // Handle navigation from branch list (data object)
    if (data) {
      setBranchId(data.id || "");
    }
    // Handle navigation back from edit page (branch_id)
    else if (branch_id) {
      setBranchId(branch_id);
    }
  }, [data, branch_id]);

  //axios api encryption call
  const axios = AxiosApiCall();

  const fetchAllproductList = async () => {
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }

      const payload = {
        per_page,
        page: current_page,
        branch_id: branchId
      };

      // console.log("form data", payload);

      const response = await axios.post(
        ApiServices.getAllBranchProduct,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      const resData = response.data?.data || {};
      const status = response.data?.status;
      const message = response.data?.message;

      if (status === "200" || status === 200) {
        const productsData = Array.isArray(resData.data) ? resData.data : [];
        setProducts(productsData);

        setTotal(resData.total || productsData.length);
        setCurrentPage(resData.current_page || 1);
        setPerPage(resData.per_page || 20);

        toast.success(message, { toastId: "branch-product-fetch-success" });
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      // console.error("Fetch error:", error);
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchAllproductList();
  // }, [current_page, per_page]);

  useEffect(() => {
    if (branchId) {
      fetchAllproductList();
    }
  }, [branchId, current_page, per_page]);



  const handleDeleteConfirmation = (Id) => {
    setConfirmationLoading(true);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      setConfirmationLoading(false);
      if (result.isConfirmed) {
        handleDeleteProduct(Id);
      }
    });
  };

  const handleDeleteProduct = async (Id) => {
    const formData = {
      id: Id,
    };
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }
      const response = await axios.delete(ApiServices.deleteBranchProduct, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: formData,
        withCredentials: true,
      });

      const updatedProduct = products.filter(
        (product) => product.id !== Id
      );
      setProducts(updatedProduct);

      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message);
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };


  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const handleActivateConfirmation = (Id, isActivated) => {
    const actionText = isActivated ? "Deactivate" : "Activate";
    const confirmButtonColor = isActivated ? "#d33" : "#3085d6";

    setConfirmationLoading(true);
    Swal.fire({
      title: `Are you sure you want to ${actionText} this product?`,
      text: `This will ${isActivated ? "deactivate" : "activate"} the product.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor,
      cancelButtonColor: "#aaa",
      confirmButtonText: `Yes, ${actionText} it!`,
    }).then((result) => {
      setConfirmationLoading(false);
      if (result.isConfirmed) handleActivateProduct(Id, isActivated);
    });
  };

  const handleActivateProduct = async (id, isActivated) => {
    setConfirmationLoading(true);
    const formData = {
      id,
      is_enabled: isActivated ? 0 : 1,
    };
    // console.log("form data", formData);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");

      const response = await axios.post(ApiServices.activateDeactivate, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      const { status, message } = response.data;
      if (status === 200) {
        toast.success(`Product ${isActivated ? "deactivated" : "activated"} successfully`);
        await fetchAllproductList();
      } else {
        toast.error(message || "Something went wrong");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Activation failed");
    } finally {
      setConfirmationLoading(false);
    }
  };



  // Define Expandable Component for Actions
  const ExpandableComponent = ({ data }) => {
    const isActivated = data.is_enabled === true || data.is_enabled === 1;
    const btnLabel = isActivated ? "Deactivate" : "Activate";
    const iconColor = isActivated ? "text-dash3" : "text-dash";

    return (
      <div className="flex justify-start p-4 relative">


        {permissions.some((p) => p.name === "admin.view") && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/products/details" state={{ data }}>
              <Eye className="w-5 h-5 text-darkGreen3 " />
            </Link>
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-darkGreen3 text-xs px-2 py-1 rounded">
              Details
            </div>
          </div>
        )}

        {permissions.some((p) => p.name === "admin.edit") && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/products/edit" state={{ data }}>
              <PencilSquare className="w-5 h-5 text-dash4 " />
            </Link>
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash4 text-xs px-2 py-1 rounded">
              Edit
            </div>
          </div>
        )}

        {/* {permissions.some((p) => p.name === "admin.create") && (
          <div className="mx-2 my-2 group relative">
            <button onClick={() => handleDeleteConfirmation(data.id)} disabled={confirmationLoading}>
              <Trash className="w-5 h-5 text-dash3 " />
            </button>
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash3 text-xs px-2 py-1 rounded">
              Delete
            </div>
          </div>
        )} */}
        {permissions.some((p) => p.name === "branch.create") && (
          <div className="mx-2 my-2 group relative">
            <button
              onClick={() => handleActivateConfirmation(data.id, isActivated)}
              disabled={confirmationLoading}
            >
              <ShieldFillPlus className={`w-5 h-5 ${iconColor}`} />
            </button>
            <div className={`absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block ${iconColor} text-xs px-2 py-1 rounded`}>
              {btnLabel}
            </div>
          </div>
        )}
      </div>
    );
  };



  const columns = [
    {
      name: "Product Name",
      selector: (row) => (row.product_units_name ? row.product_units_name.replace(/_/g, ' ').toUpperCase() : ""),
      sortable: true,
      width: "200px",
    },
    {
      name: "Product Code",
      selector: (row) => (row.product_code ? row.product_code.toUpperCase() : ""),
      sortable: true,
      width: "180px",
    },
    {
      name: "Unit",
      selector: (row) => (row.unit ? row.unit.toUpperCase() : ""),
      sortable: true,
      width: "100px",
    },
    {
      name: "Price",
      selector: (row) => (row.base_price ? CurrencyFormatter(row.base_price) : ""),
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      sortable: true,
      cell: (row) => (
        <span className={row.is_enabled ? "text-dash" : "text-dash3"}>
          {row.is_enabled ? "ACTIVE" : "INACTIVE"}
        </span>
      ),
      width: "100px",
    },
    {
      name: "Date Created",
      selector: (row) => row.created_at ? formatDate(row.created_at) : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
  ];



  const filteredItems = products.filter(item => {
    if (!item) return false;
    const searchStr = filterText.toLowerCase();
    return (
      String(item.product_units_name || '').toLowerCase().includes(searchStr) ||
      String(item.product_code || '').toLowerCase().includes(searchStr) ||
      String(item.unit || '').toLowerCase().includes(searchStr) ||
      String(item.base_price || '').includes(searchStr) ||
      String(item.product_categories_name || '').toLowerCase().includes(searchStr)
    );
  });


  const sortedData = [...filteredItems].sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });

  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
            <nav className="bg-gray-200 py-0 px-4 rounded-lg">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Operations
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Branch
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Stock
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">List</p>
                </li>
              </ol>
            </nav>
          </section>
          <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
            <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
              <input
                type="search"
                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                placeholder="Search"
                value={filterText}
                onChange={handleFilter}
              />
            </div>
            <Link
              to="/operations/branch/list"
              className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            >
              <span className="flex justify-center sm:justify-start mx-2">
                <ArrowLeftSquareFill className="mr-2" />
                Go Back
              </span>
            </Link>
            {/* {permissions.some(permission => permission.name === 'admin.view') && (
              <Link
                to="/operations/branch/products/create"
                className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              >
                <span className="flex justify-center sm:justify-start mx-2">
                  <PlusSquareFill className="mr-2" />
                  Create Branch Stock
                </span>
              </Link>
            )} */}
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <DataTable
              columns={columns}
              data={sortedData}
              pagination
              paginationServer
              paginationTotalRows={total}
              paginationDefaultPage={current_page}
              paginationPerPage={per_page}
              onChangePage={setCurrentPage}
              onChangeRowsPerPage={(perPage) => {
                setPerPage(perPage);
                setCurrentPage(current_page);
              }}
              highlightOnHover
              striped
              customStyles={CustomStyles}
              noDataComponent={
                <div className="p-4 text-center text-gray-500">
                  {products.length === 0 ? "No products stock available" : "No matching products stock  found"}
                </div>
              }
              expandableRows
              expandableRowsComponent={ExpandableComponent}
              progressPending={loading}
              progressComponent={<Spinner />}
              persistTableHead
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default BranchProductList;




